import script from "./OTabelaAtributos.vue?vue&type=script&lang=ts&setup=true"
export * from "./OTabelaAtributos.vue?vue&type=script&lang=ts&setup=true"

import "./OTabelaAtributos.vue?vue&type=style&index=0&id=3a503b29&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a503b29"]])

export default __exports__